@if (variant() === 'card') {
    <span class="head">
        @if (dragHandle()) {
            <span [title]="priorityTitle()" cdkDragHandle class="prio handle"><span></span><span></span><span></span></span>
        } @else {
            <span [title]="priorityTitle()" class="prio"><span></span><span></span><span></span></span>
        }
        <ng-container [ngTemplateOutlet]="typeTpl"></ng-container>
        <a [href]="href()" class="id" target="_blank">{{ id() }}</a>
        @if (parentId()) {
            <a [href]="parentHref()" [title]="parentTitle()" class="parent" target="_blank">{{ parentId() }}</a>
        }
        @if (prCount()) {
            <span class="pr" title="Open pull request"><i class="fa-regular fa-code-pull-request"></i>{{ prCount() }}</span>
        }
        @if (owner(); as owner) {
            <app-avatar [name]="owner.name" [seed]="owner.seed ?? null" [tooltip]="owner.name" class="owner" size="xs"></app-avatar>
        }
    </span>
    <a [href]="href()" [title]="title()" class="title" target="_blank">{{ title() }}</a>
    <ng-container [ngTemplateOutlet]="pathTpl"></ng-container>
    @if (hours(); as hours) {
        <span [class.over]="hours.over" [title]="hours.title" class="hours"><i class="fa-regular fa-clock"></i>{{ hours.label }}</span>
    }
    @if (showChanged()) {
        <span class="changed-line">{{ changedBy() }} · {{ changedWhen() }}</span>
    }
} @else {
    @if (dragHandle()) {
        <span [title]="priorityTitle()" cdkDragHandle class="prio handle"><span></span><span></span><span></span></span>
    } @else {
        <span [title]="priorityTitle()" class="prio"><span></span><span></span><span></span></span>
    }
    <span class="number">
        <a [href]="href()" class="id" target="_blank">{{ id() }}</a>
        @if (parentId()) {
            <a [href]="parentHref()" [title]="parentTitle()" class="parent" target="_blank">{{ parentId() }}</a>
        }
    </span>
    <span class="main">
        <span class="title-line">
            <ng-container [ngTemplateOutlet]="typeTpl"></ng-container>
            <a [href]="href()" [title]="title()" class="title" target="_blank">{{ title() }}</a>
        </span>
        <ng-container [ngTemplateOutlet]="pathTpl"></ng-container>
    </span>
    @if (showChanged()) {
        <span class="changed">
            <span>{{ changedBy() }}</span>
            <span class="when">{{ changedWhen() }}</span>
        </span>
    }
    <span class="pr-cell">
        @if (prCount()) {
            <span class="pr" title="Open pull request"><i class="fa-regular fa-code-pull-request"></i>{{ prCount() }}</span>
        }
    </span>
    <span class="status-cell">
        <app-status-badge [class.dark]="statusTone() === 'dark'"
                          [tone]="statusTone() === 'dark' ? 'neutral' : $any(statusTone())"
                          variant="tag">{{ status() }}</app-status-badge>
        @if (hours(); as hours) {
            <span [class.over]="hours.over" [title]="hours.title" class="hours">{{ hours.label }}</span>
        }
    </span>
}

<ng-template #typeTpl>
    @if (typeStyle(); as typeStyle) {
        <i [attr.aria-label]="type()" [class]="'type fa-regular ' + typeStyle.icon + ' tone-' + typeStyle.tone" [title]="type()" role="img"></i>
    }
</ng-template>

<ng-template #pathTpl>
    <span class="path">
        <b [style.color]="clientColor()">{{ client() }}</b>
        @for (part of pathParts(); track $index) {
            <span class="sep">›</span>
            @if (part.href) {
                <a [href]="part.href" [title]="part.label" target="_blank">{{ part.label }}</a>
            } @else {
                <span>{{ part.label }}</span>
            }
        }
    </span>
</ng-template>
